import { type TPagination as TApiPagination } from '@core/api'

import { type TPagination } from '@core/models'

export const convertPagination = (apiPagination: TApiPagination): TPagination => {
    return apiPagination
}
